import React from 'react';
import * as S from './EmptySearchResult.styled';
import PropTypes from 'prop-types';

const EmptySearchResult = ({ title }) => {
  return <S.EmptySearchResult>{title}</S.EmptySearchResult>;
};

EmptySearchResult.propTypes = {
  title: PropTypes.string.isRequired,
};

export default EmptySearchResult;
